(function () {
  'use strict';

  const SEP = ' - ';

  function init(root) {
    if (root.dataset.athenaSplitReady) return;
    root.dataset.athenaSplitReady = '1';

    const radios = Array.from(root.querySelectorAll('.a-split__real'));
    const bases = Array.from(root.querySelectorAll('[data-athena-base]'));
    const sizes = Array.from(root.querySelectorAll('[data-athena-size]'));
    const sizeStep = root.querySelector('[data-athena-sizestep]');
    const note = root.querySelector('[data-athena-size-note]');
    if (!radios.length || !bases.length) return;

    const lastSize = {};

    function currentValue() {
      const hit = radios.find((r) => r.checked);
      return hit ? hit.value : '';
    }

    function select(value) {
      const target = radios.find((r) => r.value === value);
      if (!target || target.checked) return;
      radios.forEach((r) => { r.checked = r === target; });
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function paint() {
      const value = currentValue();
      const base = value.split(SEP)[0];
      const parts = value.split(SEP);
      if (parts.length > 1) lastSize[base] = value;

      bases.forEach((b) => {
        const on = b.dataset.athenaBase === base;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });

      const forBase = sizes.filter((s) => s.dataset.base === base);
      sizes.forEach((s) => { s.hidden = s.dataset.base !== base; });
      forBase.forEach((s) => {
        const on = s.dataset.athenaSize === value;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-pressed', String(on));
      });

      if (sizeStep) sizeStep.hidden = forBase.length === 0;
      if (note) note.textContent = forBase.length ? 'Shown only for ' + base : '';
    }

    bases.forEach((btn) => {
      btn.addEventListener('click', () => {
        const base = btn.dataset.athenaBase;
        const solo = btn.dataset.solo;
        if (solo) {
          select(solo);
        } else {
          const remembered = lastSize[base];
          const first = sizes.find((s) => s.dataset.base === base);
          select(remembered || (first && first.dataset.athenaSize) || '');
        }
        paint();
      });
    });

    sizes.forEach((btn) => {
      btn.addEventListener('click', () => {
        select(btn.dataset.athenaSize);
        paint();
      });
    });

    root.addEventListener('change', (e) => {
      if (e.target && e.target.classList.contains('a-split__real')) paint();
    });

    paint();
  }

  function scan() {
    document.querySelectorAll('[data-athena-split]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
